export const branchSubscriptionSchema =({list})=>{
    const {
        items: subscriptions,
        status: subscriptionStatus,
    } = list.subscription;

    const {
        items: restaurants,
        status: restaurantStatus,
    } = list.restaurant;

    const {
        items: branches,
        status: branchStatus,
    } = list.branch;

    return(
        {
            template: {
                type: 'select',
                label: 'Type',
                options: subscriptionStatus === "success" ? subscriptions : {},
                validation: (value) => {
                    if (value.trim() === '') return 'Type is required';
                    return null;
                },
            },
            restaurant: {
                type: 'select',
                label: 'Restaurant',
                options: restaurantStatus === "success" ? restaurants : {},
                validation: (value) => {
                    if (value.trim() === '') return 'Restaurant is required';
                    return null;
                },
            },
            branch: {
                type: 'select',
                label: 'Branch',
                options: branchStatus === "success" ? branches : {},
                validation: (value) => {
                    if (value.trim() === '') return 'Branch is required';
                    return null;
                },
            }
        }
    )
}
